import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  AlertModule,
  LoadingSpinnerModule,
} from '@proximus/ng-common-components';
import { TranslationModule } from '@proximus/ng-common';

import { AuB2B2EOnlyGuard } from '../guards/au-b2b2e-only.guard';
import { FormsModule } from '@angular/forms';
import { PublicWifiPxsplusHowtoinstallComponent } from './public-wifi-pxsplus-howtoinstall/public-wifi-pxsplus-howtoinstall.component';
import { PublicWifiPxsplusHotspotComponent } from './public-wifi-pxsplus-hotspot/public-wifi-pxsplus-hotspot.component';
import { PublicWifiPxsplusNoSimcardComponent } from './public-wifi-pxsplus-no-simcard/public-wifi-pxsplus-no-simcard.component';
import { PublicWifiPxsplusComponent } from './public-wifi-pxsplus-container/public-wifi-pxsplus.component';
import { PublicWifiPxplusRoutingModule } from './public-wifi-pxsplus-routing.module';
import { EffectsModule } from '@ngrx/effects';
import { PublicWifiPxsplusEffects } from './store/effects/public-wifi-pxsplus.effects';
import { PublicWifiPxsplusService } from './services/public-wifi-pxsplus.service';
import { PublicWifiPxsplusConfigurationComponent } from './public-wifi-pxsplus-configuration/public-wifi-pxsplus-configuration.component';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  declarations: [
    PublicWifiPxsplusHowtoinstallComponent,
    PublicWifiPxsplusHotspotComponent,
    PublicWifiPxsplusConfigurationComponent,
    PublicWifiPxsplusNoSimcardComponent,
    PublicWifiPxsplusComponent,
  ],
  imports: [
    CommonModule,
    TranslationModule,
    PublicWifiPxplusRoutingModule,
    EffectsModule.forFeature([PublicWifiPxsplusEffects]),
    FormsModule,
    LoadingSpinnerModule,
    AlertModule,
    SharedModule,
  ],
  providers: [AuB2B2EOnlyGuard, PublicWifiPxsplusService],
})
export class PublicWifiPxsplusModule {}
